import React from 'react';
import aqLogo from "../assets/img/aq-logo-black.png";
import { Link } from 'react-router-dom';
import {PAGE_NAV} from "configs/page";
import Languages from '../components/Languages';

const LoginHeader = () => {
    return (
            <div className="header">
                <div className='hader-container'>
                    <p className="page-logo"><Link to={PAGE_NAV.HOME} title="affiliateQuarter.com"><img src={aqLogo} alt="Affiliate quarter" /></Link></p>
                    <Languages />
                </div>
            </div>
    );
}

export default LoginHeader;